import React, { Component } from 'react';
import queryString from 'query-string'
import { getBloodSugarById, getBloodPressureById, getThyroidById, deleteThyroid, deleteVitalsImage } from '../../../services';
import EnhancedThyroid from './EnhancedThyroid';
import EnhancedBloodSugar from './EnhancedBloodSugar';
import EnhancedBloodPressure from './EnhancedBloodPressure';
import Loader from '../../../Loader';

class EditVital extends Component {

  state = {
    record: null,
    recordId: null,
    files: null,
    loading: true,

  }

  async componentDidMount() {
    const recordId = this.props.match.params.id;
    // const { state: disease } = this.props.location;
    const values = queryString.parse(this.props.location.search);
    
    // console.log(disease);
      
    if(values.disease == undefined ) {
      return
    }

    let data = {
      recordId
    }

    let response;

    if(values.disease == 1) {
      response = await getThyroidById(data);
    } else if(values.disease == 2) {
      response = await getBloodSugarById(data);
    } else if(values.disease == 3) {
      response = await getBloodPressureById(data);
    }

    let files = response.data.record.files.map((file, idx) => {
      return {fileId: file._id, filename: file.filename, uploaded: true }
    })

    this.setState(prevState => ({
      loading: false,
      record: response.data.record,
      recordId,
      type: values.disease,
      files
    }))
  }

  deleteImage = async (imageId) => {
    let data = {
      recordId: this.state.recordId,
      type: this.state.type,
      imageId
    }

    const response = await deleteVitalsImage({data});

    this.setState(prevState => ({
      files: prevState.files.filter(file => file.fileId !== imageId)
    }))
  }

  renderForm = () => {
    
    const { record, recordId, files } = this.state;
    // const { state: disease } = this.props.location;
    const values = queryString.parse(this.props.location.search);
    console.log(record);
    if(values.disease == 1) {
      return ( 
        <EnhancedThyroid
          recordId={recordId} 
          date={new Date(record.testDate)}
          lab={record.lab}
          t3={record.t3}
          t4={record.t4}
          ft3={record.ft3}
          ft4={record.ft4}
          tsh={record.tsh}
          title={record.documentTitle}
          description={record.documentDescription}
          files={files}
          formType="edit"
          deleteImage={this.deleteImage}
        />
      )
    } else if(values.disease == 2) {
      return (
        <EnhancedBloodSugar 
          recordId={recordId}
          date={new Date(record.testDate)}
          lab={record.lab}
          hb={record.HbA1c}
          urineSugarPP={record.urineSugarPP}
          urineSugarF={record.urineSugarF}
          preBloodSugar={record.preMealBloodSugar}
          postBloodSugar={record.postMealBloodSugar}
          title={record.documentTitle}
          description={record.documentDescription}
          files={files}
          formType="edit"
          deleteImage={this.deleteImage}
        />
      )
    } else if(values.disease == 3) {
      return (
        <EnhancedBloodPressure
          recordId={recordId} 
          date={new Date(record.testDate)}
          lab={record.lab}
          pulseRate={record.pulseRate}
          bps={record.systolicBloodPressure}
          bpd={record.diastolicBloodPressure}
          title={record.documentTitle}
          description={record.documentDescription}
          files={files}
          formType="edit"
          deleteImage={this.deleteImage}
        />
      )
    }
  }
    

  render() {

    console.log(this.state);

    if(this.state.loading == true) {
      return (
        <Loader />
      )
    }

    return (
      <div>
        {this.renderForm()}
      </div>
    )
  }
}

export default EditVital;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/PregnancyVitals/PregnancyVitalsView/EditVital.js